import { TextLegacy } from '@/components/common'
import { LinkButton } from '@/components/common/buttons'
import { RouteType } from '@/components/common/buttons/LinkButton'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'

interface LinkButtonGotoPolicyPageProps {
  text: string
  fontSize?: FontResponsiveSizeType
  routeType?: RouteType
  openNewWindow?: boolean
  url: string | { pathname: string }
  color?: string
}

const LinkButtonGotoPolicyPage = ({
  text,
  fontSize = { xs: 12, md: 14 },
  routeType = 'push',
  openNewWindow = false,
  url,
  color = 'blue500',
}: LinkButtonGotoPolicyPageProps) => {
  return (
    <LinkButton style={{ display: 'inline' }} routeType={routeType} openNewWindow={openNewWindow} url={url} shallow>
      <TextLegacy color={color} size={fontSize}>
        {text}
      </TextLegacy>
    </LinkButton>
  )
}

export default LinkButtonGotoPolicyPage
